import React from "react";
import SeoMeta from "../components/meta/index.jsx";
import CarImport from "../components/carImport/index.jsx";

export default function ImportCar() {
  return (
    <>
      <SeoMeta
        title="Japanese Car Import in Pakistan | Famewheels"
        desc="Discover your dream import car from Japan to Pakistan with Famewheels, and our user-friendly platform simplifies the process, ensuring the best import car buying experience from start to finish."
        url="new-cars"
      />

      <CarImport />
    </>
  );
}
